webpackJsonp([1],{

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_database__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_database__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_sweetalert2__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_snackbar__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_alert__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_dist_vuetify_min_css__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_styles_css__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_styles_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_sweetalert2__["a" /* default */]);

// Inject Vue, replace the need to import Vue into snackbar, dependencies are also clearer
var alert = Object(__WEBPACK_IMPORTED_MODULE_10__modules_alert__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]);
var snackbar = Object(__WEBPACK_IMPORTED_MODULE_9__modules_snackbar__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]);
var store = Object(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */], alert, __WEBPACK_IMPORTED_MODULE_3_firebase_app__, __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */], snackbar);

// console.log('[Dev Only]', 'Vue Version: ', Vue.version)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
// Vue.config.devtools = false

/**
 * Initialize Firebase
 */
var _initDB = function _initDB() {
  __WEBPACK_IMPORTED_MODULE_3_firebase_app__["initializeApp"]({
    apiKey: "AIzaSyBYgk9px5iGzIj77Sj39z_gRsFCA9GrleE",
    authDomain: "notes-2go.firebaseapp.com",
    databaseURL: "https://notes-2go.firebaseio.com",
    projectId: "notes-2go",
    storageBucket: "notes-2go.appspot.com"
  });
};

/**
 * Sign in user anonymously
 */
var _initUser = function _initUser() {
  if (__WEBPACK_IMPORTED_MODULE_3_firebase_app__["auth"]().currentUser) return;

  __WEBPACK_IMPORTED_MODULE_3_firebase_app__["auth"]().signInAnonymously().catch(function (error) {
    console.error('Firebase anonymously sign in error, please check Firebase rules', error);
  });
};

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  alert: alert,
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  snackbar: snackbar,
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  created: function created() {
    _initDB();
    _initUser();
  }
});

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c4b914_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(115)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c4b914_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c4b914_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppNavbar_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_167b6f32_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppNavbar_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(118)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-167b6f32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_167b6f32_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppNavbar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_167b6f32_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppNavbar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 118:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"yellow lighten-4"},[_c('v-toolbar-title',[_c('router-link',{staticClass:"clickable",attrs:{"to":_vm.menuHome,"router":"","tag":"span"}},[_vm._v(_vm._s(_vm.appName))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{staticClass:"toolbar__search mr-2",attrs:{"append-icon":"search","flat":"","label":"Code search","solo-inverted":"","autofocus":_vm.searchAutofocus,"append-icon-cb":_vm.searchNote},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.searchNote($event)}},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)}
var staticRenderFns = []


/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da3d5934_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(121)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da3d5934"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da3d5934_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da3d5934_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 121:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"white--text pr-2",attrs:{"dark":""}},[_c('v-spacer'),_vm._v("\n  💖 Proudly brought to you by "),_c('a',{attrs:{"href":"https://aiwebstudio.com","target":"_blank"}},[_vm._v("Active Improvement Web Studio")])],1)}
var staticRenderFns = []


/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('app-navbar',_vm._b({},'app-navbar',{appName: _vm.appName},false)),_vm._v(" "),_c('v-content',[_c('router-view')],1),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []


/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_View__ = __webpack_require__(178);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_2__views_Home__["a" /* default */] }, { path: '/view/:id', component: __WEBPACK_IMPORTED_MODULE_3__views_View__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
}));

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9788a5a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(127)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b9788a5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9788a5a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9788a5a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 127:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fab-container"},[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"red","dark":"","fab":""},on:{"click":_vm.onClick},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Start a new note")])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"color":_vm.backgroundColor,"dismissible":_vm.dismissible,"transition":_vm.transition},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"dark":_vm.iconDarkTheme}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []


/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteForm_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273971da_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteForm_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(145)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-273971da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273971da_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273971da_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 145:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteDelete_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8079f40e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteDelete_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(169)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8079f40e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteDelete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8079f40e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteDelete_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8079f40e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteDelete_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[(_vm.showIcon)?_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":_vm.onClick},slot:"activator"},[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)}
var staticRenderFns = []


/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteShare_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d77ceaa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteShare_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(172)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d77ceaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteShare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d77ceaa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteShare_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d77ceaa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteShare_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 172:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[(_vm.showIcon)?_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":_vm.onClick},slot:"activator"},[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("share")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Share")])],1)}
var staticRenderFns = []


/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","md10":"","mt-2":""}},[_c('v-card',{staticClass:"elevation-3"},[_c('v-toolbar',{attrs:{"color":"brown"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("My Notes")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"mr-3"},[_c('note-delete'),_vm._v(" "),_c('note-share')],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',[_c('input',{attrs:{"type":"hidden","name":"id"},domProps:{"value":_vm.id}}),_vm._v(" "),(_vm.mode === 'edit')?_c('v-text-field',{attrs:{"hint":"Code must be unique, can be used to retrieve your notes later","label":"Code","persistent-hint":"","required":"","error-messages":_vm.errorsCode},on:{"input":_vm.onInputCode},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Notes","multi-line":"","required":"","textarea":"","error-messages":_vm.errorsNotes,"rows":10},on:{"input":function($event){_vm.$v.notes.$touch()}},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}}),_vm._v(" "),(_vm.isSaveButtonVisible)?_c('v-btn',{staticClass:"success",attrs:{"block":"","large":"","disabled":_vm.isSaveButtonDisabled,"loading":_vm.isSaving},on:{"click":_vm.submit}},[_vm._v("\n          Save\n        ")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"color":_vm.getSetting('backgroundColor'),"top":_vm.getSetting('top'),"right":_vm.getSetting('right'),"bottom":_vm.getSetting('bottom'),"left":_vm.getSetting('left'),"timeout":_vm.timeout},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[(_vm.getSetting('icon'))?_c('span',{staticClass:"mr-3"},[_vm._v(_vm._s(_vm.getSetting('icon')))]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.getSetting('text'))+"\n  "),_c('v-spacer'),_vm._v(" "),(_vm.getSetting('dismissible'))?_c('v-btn',{attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){_vm.visible = false}}},[_c('v-icon',{attrs:{"color":_vm.getSetting('dismissButtonColor')}},[_vm._v("cancel")])],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":""}},[_c('note-alert')],1),_vm._v(" "),_c('note-form'),_vm._v(" "),_c('note-snackbar'),_vm._v(" "),_c('note-add')],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0149c7e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(179)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0149c7e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0149c7e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0149c7e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 179:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteDisplay_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_822e2de8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteDisplay_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(181)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-822e2de8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteDisplay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_822e2de8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteDisplay_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_822e2de8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteDisplay_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 181:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm10":"","mt-2":""}},[_c('v-card',{staticClass:"elevation-3"},[(_vm.notes)?_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.formattedNotes)}}):_c('v-card-text',{staticClass:"text-xs-center py-5"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"primary"}})],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":""}},[_c('note-alert')],1),_vm._v(" "),_c('note-display',{attrs:{"notes":_vm.notes}}),_vm._v(" "),_c('note-snackbar'),_vm._v(" "),_c('note-add')],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 242:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(278);







/**
 * Model Logic
 * - id is generated by the database, autoincrement
 * - code must be unique, 3 to 30 characters
 * - notes must not be blank
 * Mutation Logic (might change)
 * - id = 0, new entry, ensure code is unique to be inserted into db (post)
 * - id > 0 and code exact match db, edit allowed, code must be unique (post)
 * - id > 0 and 2 character code matching last 2 in db, view mode, do not disclose code (get)
 * - id > 0 and code exact match db, edit mode (get)
*/
var defaultFormFields = {
  // System generated
  id: '',
  // User input
  code: '',
  notes: ''

  // Form states, structure supports only 1 visible form
};var defaultFormStates = {
  isDirty: false,
  isLoading: false,
  mode: 'edit',
  skipConfirmationDirty: false
};

function makeStore(Vue, alert, firebase, router, snackbar) {
  var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultFormFields, defaultFormStates, {
    formTimestamp: new Date().getTime()
  });

  Vue.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

  return new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: state,
    actions: Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */])(Vue, alert, firebase, router, snackbar),
    getters: Object(__WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */])(),
    mutations: Object(__WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */])(defaultFormFields, defaultFormStates)
  });
}

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeGetters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Getters = function () {
  function Getters() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Getters);

    this.canLeaveWithoutConfirmation = function (state) {
      if (!_this.isDataEditable) return true;
      if (!state.isDirty) return true;
      if (state.skipConfirmationDirty) return true;
      return false;
    };

    this.codeMinLength = function () {
      return 3;
    };

    this.codeMaxLength = function () {
      return 30;
    };

    this.isDataEditable = function (state) {
      return state.mode === 'edit';
    };

    this.linkViewOnly = function (state) {
      if (state.id === '') return '';

      var link = window.location.protocol + '//' + window.location.hostname + (location.port ? ':' + location.port : '') + '/' + 'view/' + state.id;
      return link;
    };
  }
  /**
   * Ensure leaving the current page is acceptable without asking user for confirmation
   */


  // Code field validation rules: min length


  // Code field validation rules: max length


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Getters, [{
    key: 'export',
    value: function _export() {
      return {
        canLeaveWithoutConfirmation: this.canLeaveWithoutConfirmation,
        codeMinLength: this.codeMinLength,
        codeMaxLength: this.codeMaxLength,
        isDataEditable: this.isDataEditable,
        linkViewOnly: this.linkViewOnly
      };
    }
  }]);

  return Getters;
}();

function makeGetters() {
  return new Getters().export();
}

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);





var feedbacks = __webpack_require__(275);
var firebaseNotes = __webpack_require__(276);
var formNotes = __webpack_require__(277);

var Actions = function () {
  function Actions(Vue, alert, firebase, router, snackbar) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Actions);

    this._error = feedbacks._error;
    this._success = feedbacks._success;
    this._resetFormNote = formNotes._resetFormNote;
    this._deleteNote = firebaseNotes._deleteNote;
    this._insertNote = firebaseNotes._insertNote;
    this._searchByCode = firebaseNotes._searchByCode;
    this._updateNote = firebaseNotes._updateNote;

    this.deleteNote = function (context) {
      // Ask user for confirmation
      _this.Vue.swal({
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        text: 'Once deleted, note cannot be recovered.',
        title: 'Delete note?',
        type: 'warning'
      }).then(function (result) {
        if (!result.value) return;

        _this._deleteNote(context, context.state.id);
      });
    };

    this.shareNote = function (context) {
      var inputClass = 'view-only-link';
      _this.Vue.swal({
        confirmButtonText: 'Copy Link',
        input: 'text',
        inputClass: inputClass,
        inputValue: context.getters.linkViewOnly,
        showCloseButton: true,
        title: 'Share with others',
        type: 'info',
        onOpen: function onOpen() {
          // Cannot use .then as Firefox does not allow copy to clipboard function outside of onClick event
          document.querySelector('.swal2-confirm').addEventListener('click', function () {
            document.querySelector('.' + inputClass).select();
            document.execCommand('Copy');

            _this._success(context, 'Link copied to clipboard!', '📋', 2500);
          });
        }
      });
    };

    this.startNewNote = function (context) {
      if (context.getters.canLeaveWithoutConfirmation) {
        _this._resetFormNote(context);
        _this._success(context, 'New note ready', '⭐');
        return;
      }

      // Ask user for confirmation
      _this.Vue.swal({
        cancelButtonColor: '#d33',
        cancelButtonText: 'No, let me save first',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        text: 'Changes made have not been saved.',
        title: 'Start a new note?',
        type: 'warning'
      }).then(function (result) {
        if (!result.value) return;
        _this._resetFormNote(context);
        _this._success(context, 'New note ready', '⭐');
      });
    };

    this.submitFormNote = function (context, payload) {
      context.commit('setLoadingFlag', true);

      // Validate field: code
      if (payload.code.length < context.getters.codeMinLength) {
        return _this._error(context, 'Code is invalid');
      }

      // Validate field: notes
      if (payload.notes.length === 0) {
        return _this._error(context, 'Notes is required');
      }

      // Ensure data is formatted correctly
      var formattedPayload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(payload, {
        code: _this.Vue.filter('formatCode')(payload.code)
      });

      // New Note
      if (payload.id.length === 0) {
        // Firebase .push() returns a promise, results won't be returned by function
        return _this._insertNote(context, formattedPayload);
      }

      // Update existing Note
      return _this._updateNote(context, formattedPayload);
    };

    this.submitSearch = function (context, searchText) {
      var performSearch = function performSearch() {
        var code = _this.Vue.filter('formatCode')(searchText);
        _this._searchByCode(code).once('value').then(function (snapshot) {
          if (snapshot.val() === null) {
            // Not found
            return _this._error(context, 'Note \'' + searchText + '\' does not exist');
          }

          // Found Note
          // Reture to home page, which allows edit
          _this.router.push('/');

          // Load data into Vuex store
          var valInDB = snapshot.val();

          var _Object$getOwnPropert = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(valInDB),
              _Object$getOwnPropert2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_Object$getOwnPropert, 1),
              id = _Object$getOwnPropert2[0];

          context.commit('resetFormFields');
          context.commit({ type: 'set', property: 'id', value: id });
          context.commit({ type: 'set', property: 'code', value: valInDB[id].code });
          context.commit({ type: 'set', property: 'notes', value: valInDB[id].notes });
          context.commit('resetFormStates');
          context.commit({ type: 'set', property: 'formTimestamp', value: new Date().getTime() });

          _this._success(context, '\'' + valInDB[id].code + '\' loaded', '👍');
        }).catch(function (error) {
          // Database connection error?
          return _this._error(context, '[FB] Error encountered: \'' + error + '\'');
        });
      };

      if (context.getters.canLeaveWithoutConfirmation) {
        performSearch();
        return;
      }

      // Ask user for confirmation
      _this.Vue.swal({
        cancelButtonColor: '#d33',
        cancelButtonText: 'No, let me save first',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        text: 'Changes made have not been saved.',
        title: 'Proceed with search?',
        type: 'warning'
      }).then(function (result) {
        if (!result.value) return;
        performSearch();
      });
    };

    this.viewNote = function (context, id) {
      var ref = _this.firebase.database().ref('notes/' + id);
      ref.once('value').then(function (snapshot) {
        var valInDB = snapshot.val();
        // id is not in the database
        if (valInDB === null) {
          return _this._error(context, 'Note does not exist.');
        }

        // Found Note
        context.commit('resetFormFields');
        context.commit({ type: 'set', property: 'id', value: id });
        context.commit({ type: 'set', property: 'notes', value: valInDB.notes });
        context.commit('resetFormStates');
        context.commit({ type: 'set', property: 'mode', value: 'View' });
        context.commit({ type: 'set', property: 'formTimestamp', value: new Date().getTime() });

        _this.alert.hide();
        context.commit('setLoadingFlag', false);
      }).catch(function (error) {
        // Database connection error?
        return _this._error(context, '[FB#R] Error encountered: \'' + error + '\'');
      });
    };

    this.Vue = Vue;
    this.alert = alert;
    this.firebase = firebase;
    this.router = router;
    this.snackbar = snackbar;
  }

  // Note: Using arrow functions within external modules will prevent `this` from working


  /**
   * Delete current note
   */


  /**
   * Open dialog box, show View Only link and button to copy link to clipboard
   */


  /**
   * Start a new note with blank fields
   */


  /**
   * Invoked by Notes submission form
   * @param {Object} context
   * @param {Object} payload
   */


  /**
   * Search for a note by `code`
   * @param {Object} context
   * @param {String} searchText
   */


  /**
   * Search for a note by `id`, if found, note will be view only
   */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Actions, [{
    key: 'export',
    value: function _export() {
      return {
        deleteNote: this.deleteNote,
        shareNote: this.shareNote,
        startNewNote: this.startNewNote,
        submitFormNote: this.submitFormNote,
        submitSearch: this.submitSearch,
        viewNote: this.viewNote
      };
    }
  }]);

  return Actions;
}();

function makeActions(Vue, alert, firebase, router, snackbar) {
  return new Actions(Vue, alert, firebase, router, snackbar).export();
}

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_error", function() { return _error; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_success", function() { return _success; });
/**
 * Show error alert and clear loading flag
 * Always returns false as error status
 * @param {Object} context
 * @param {Object} payload
 * @return {Boolean}
 */
var _error = function _error(context, text) {
  this.alert.showError(text);
  context.commit('setLoadingFlag', false);
  return false;
};

/**
 * Show success snackbar, hide alert and clear loading flag
 * Always returns true as success status
 * @return {Boolean}
 */
var _success = function _success(context, text) {
  var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '💾';
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;

  // Configure snackbar to show success status
  this.snackbar.set('dismissible', false);
  this.snackbar.set('icon', icon);
  this.snackbar.set('text', text);
  this.snackbar.set('timeout', timeout);
  this.snackbar.set('right', false);
  this.snackbar.show();

  this.alert.hide();
  context.commit('setLoadingFlag', false);
  return true;
};

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_deleteNote", function() { return _deleteNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_insertNote", function() { return _insertNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_searchByCode", function() { return _searchByCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_updateNote", function() { return _updateNote; });
/**
 * Delete note from firebase
 */
var _deleteNote = function _deleteNote(context, id) {
  var _this = this;

  var ref = this.firebase.database().ref('notes/' + id);
  ref.once('value').then(function (snapshot) {
    var valInDB = snapshot.val();
    // id is not in the database
    if (valInDB === null) {
      return _this._error(context, 'Note does not exist.');
    }

    ref.remove();

    _this._resetFormNote(context);

    _this._success(context, 'Note deleted!', '🗑️');
  }).catch(function (error) {
    // Database connection error?
    return _this._error(context, '[FB#D] Error encountered: \'' + error + '\'');
  });
};

/**
 * Insert new Note node, ensure `code` is unique
 * @param {Object} context
 * @param {Object} payload
 * @return {Boolean}
 */
var _insertNote = function _insertNote(context, payload) {
  var _this2 = this;

  // let ref = this.firebase.database().ref('notes').orderByChild('code').equalTo(payload.code)
  this._searchByCode(payload.code).once('value').then(function (snapshot) {
    if (snapshot.val() !== null) {
      // Duplicate `code`
      return _this2._error(context, 'Code \'' + payload.code + '\' already exists, please select another code');
    }

    // Attempt to add new Note
    var data = {
      code: payload.code,
      notes: payload.notes,
      dateCreated: new Date().toISOString()
    };
    _this2.firebase.database().ref('notes').push(data).then(function (result) {
      context.commit({ type: 'set', property: 'id', value: result.key });
      context.commit({ type: 'set', property: 'code', value: payload.code });
      context.commit({ type: 'set', property: 'notes', value: payload.notes });

      return _this2._success(context, 'Saved');
    }).catch(function (_) {
      // Most likely permission error, should not happen if data is clean
      return _this2._error(context, '[FB] Error encountered trying to create a new Note, please try again later');
    });
  }).catch(function (error) {
    // Database connection error?
    return _this2._error(context, '[FB] Error encountered: \'' + error + '\'');
  });
};

/**
 * Search Notes to find node with code, returns Firebase ref
 * @param {String} code
 * @return {Object}
 */
var _searchByCode = function _searchByCode(code) {
  // Note: Create index on `code` to prevent Firebase warning and improve query speed
  return this.firebase.database().ref('notes').orderByChild('code').equalTo(code);
};

/**
 * Update Note node, ensure `code` is unique and id is valid
 * @param {Object} context
 * @param {Object} payload
 * @return {Boolean}
 */
var _updateNote = function _updateNote(context, payload) {
  var _this3 = this;

  var ref = this.firebase.database().ref('notes/' + payload.id);
  ref.once('value').then(function (snapshot) {
    var valInDB = snapshot.val();
    // payload.id is not in the database
    if (valInDB === null) {
      return _this3._error(context, 'Note data has been corrupted, please reload.');
    }

    // Code has been changed
    if (valInDB.code !== payload.code) {
      _this3._searchByCode(payload.code).once('value').then(function (snapshot) {
        if (snapshot.val() !== null) {
          // Duplicate `code`
          return _this3._error(context, 'Code \'' + payload.code + '\' already exists, please select another code');
        }

        // Update the code and notes fields
        ref.update({
          code: payload.code,
          notes: payload.notes
        }).then(function (_) {
          return _this3._success(context, 'Updated');
        }).catch(function (error) {
          // Database connection error?
          return _this3._error(context, '[FB#UCN] Update failed: \'' + error + '\'');
        });
      }).catch(function (error) {
        // Database connection error?
        return _this3._error(context, '[FB#S] Error encountered: \'' + error + '\'');
      });

      return;
    }

    // Only the notes field has been changed
    ref.update({
      notes: payload.notes
    }).then(function (_) {
      return _this3._success(context, 'Updated');
    }).catch(function (error) {
      // Database connection error?
      return _this3._error(context, '[FB#UN] Update failed: \'' + error + '\'');
    });
  }).catch(function (error) {
    // Database connection error?
    return _this3._error(context, '[FB#ID] Error encountered: \'' + error + '\'');
  });
};

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_resetFormNote", function() { return _resetFormNote; });
/**
 * Reset form by clearing all fields and setting timestamp
 */
var _resetFormNote = function _resetFormNote(context) {
  context.commit('resetFormFields');
  context.commit('resetFormStates');
  context.commit({ type: 'set', property: 'formTimestamp', value: new Date().getTime() });
};

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeMutations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Mutations = function () {
  function Mutations(defaultFormFields, defaultFormStates) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Mutations);

    this.resetFormFields = function (state) {
      for (var property in _this.defaultFormFields) {
        state[property] = _this.defaultFormFields[property];
      }
    };

    this.resetFormStates = function (state) {
      for (var property in _this.defaultFormStates) {
        state[property] = _this.defaultFormStates[property];
      }
    };

    this.setDirtyFlag = function (state, value) {
      state.isDirty = value;
    };

    this.setLoadingFlag = function (state, value) {
      state.isLoading = value;
    };

    this.setSkipConfirmationDirtyFlag = function (state, value) {
      state.skipConfirmationDirty = value;
    };

    this.set = function (state, payload) {
      state[payload.property] = payload.value;
    };

    this.defaultFormFields = defaultFormFields;
    this.defaultFormStates = defaultFormStates;
  }

  /**
   * Reture form fields to default values
   */


  /**
   * Reture form states to default values
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Mutations, [{
    key: "export",
    value: function _export() {
      return {
        resetFormFields: this.resetFormFields,
        resetFormStates: this.resetFormStates,
        setDirtyFlag: this.setDirtyFlag,
        setLoadingFlag: this.setLoadingFlag,
        setSkipConfirmationDirtyFlag: this.setSkipConfirmationDirtyFlag,
        set: this.set
      };
    }
  }]);

  return Mutations;
}();

function makeMutations(defaultFormFields, defaultFormStates) {
  return new Mutations(defaultFormFields, defaultFormStates).export();
}

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeSnackbar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * snackbar v1.0.0
 * (c) 2018 Ivan Lim
 * @license MIT
 */
var Snackbar = function () {
  function Snackbar() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Snackbar);

    this.isVisible = false;
    this.reset();
  }

  /**
   * Revert properties to default values
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Snackbar, [{
    key: 'reset',
    value: function reset() {
      this._backgroundColor = 'default';
      this._dismissButtonColor = 'white';
      this._dismissible = true;
      this._icon = '';
      this._text = '';
      this._timeout = 3000;

      // Display position
      this._top = true;
      this._right = true;
      this._bottom = false;
      this._left = false;
    }

    /**
     * Return property value if the property is valid
     * @param {String} property
     * @return {*}
     */

  }, {
    key: 'get',
    value: function get(property) {
      // if (property === 'isVisible') return this.isVisible
      if (this.hasOwnProperty('_' + property)) return this['_' + property];
      return null;
    }

    /**
     * Set property value if the property is valid
     * @param {String} property
     * @param {*} value
     * @return {Boolean}
     */

  }, {
    key: 'set',
    value: function set(property, value) {
      if (this.hasOwnProperty('_' + property)) {
        this['_' + property] = value;
        return true;
      }
      return false;
    }

    /**
     * Show snackbar
     */

  }, {
    key: 'show',
    value: function show() {
      var _this = this;

      this.isVisible = true;
      if (this.get('timeout') > 0) {
        setTimeout(function () {
          _this.hide();
        }, this.get('timeout'));
      }
    }

    /**
     * Hide snackbar and reset settings
     */

  }, {
    key: 'hide',
    value: function hide() {
      var _this2 = this;

      this.isVisible = false;
      setTimeout(function () {
        // Without timeout snackbar will revert to default before it disappears
        _this2.reset();
      }, 500);
    }
  }]);

  return Snackbar;
}();

/**
 * Factory function to create Snackbar class object
 * @param {Object} Vue
 * @return {Object<Snackbar>}
 */


function makeSnackbar(Vue) {
  // Add this.$snackbar to all Vue components
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var options = this.$options;
      if (options.snackbar) {
        this.$snackbar = options.snackbar;
      } else if (options.parent && options.parent.$snackbar) {
        this.$snackbar = options.parent.$snackbar;
      }
    }
  });

  return new Snackbar();
}

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);



/**
 * alert v1.1.0
 * (c) 2018 Ivan Lim
 * @license MIT
 */
var defaultProperties = {
  backgroundColor: 'info',
  dismissible: true,
  icon: 'info',
  iconDarkTheme: true,
  resetTimeout: 500,
  text: '',
  timeout: 0,
  transition: 'fade-transition'
};

var Alert = function Alert() {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Alert);

  this.reset = function () {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this.state, defaultProperties);
  };

  this.get = function (property) {
    return _this.state[property];
  };

  this.set = function (property, value) {
    _this.state[property] = value;
  };

  this.show = function () {
    _this.set('isVisible', true);
    if (_this.get('timeout') <= 0) return;

    // Auto hide
    setTimeout(function () {
      _this.hide();
    }, _this.get('timeout'));
  };

  this.hide = function () {
    // Setting isVisible to false should start the fade transition animation within 100ms
    _this.set('isVisible', false);

    setTimeout(function () {
      // Without timeout alert will revert to default before it disappears
      _this.reset();
    }, _this.get('resetTimeout'));
  };

  this.showError = function (text) {
    _this.set('backgroundColor', 'error');
    _this.set('icon', 'warning');
    _this.set('text', text);
    _this.show();
  };

  this.state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultProperties, {
    isVisible: false
  });
  this.reset();
}

/**
 * Revert properties to default values
 */


/**
 * Return property value if the property is valid
 * @param {String} property
 * @return {*}
 */


/**
 * Set property value if the property is valid
 * @param {String} property
 * @param {*} value
 * @return {Boolean}
 */


/**
 * Show alert
 */


/**
 * Hide alert and reset settings
 */


/**
 * Standard error alert
 */
;

/**
 * Factory function to create Alert class object
 * @param {Object} Vue
 * @return {Object<Alert>}
 */


function makeAlert(Vue) {
  // Add this.$alert to all Vue components
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var options = this.$options;
      if (options.alert) {
        this.$alert = options.alert;
      } else if (options.parent && options.parent.$alert) {
        this.$alert = options.parent.$alert;
      }
    }
  });

  return new Alert();
}

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/**
 * Global filters for notes2go v1.0.0
 * (c) 2018 Ivan Lim
 * @license MIT
 */


// `code` should be in lower case, spaces replaced by .
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatCode', function (value) {
  if (!value) return '';
  return value.toLowerCase().replace(/ /g, '.');
});

// `notes` for display purpose
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatNotesForDisplay', function (value) {
  if (!value) return '';
  return value.replace(/\n/g, '<br>');
});

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_layouts_AppNavbar__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_layouts_AppFooter__ = __webpack_require__(120);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  data: function data() {
    return {
      appName: 'notes2go'
    };
  },


  components: {
    AppNavbar: __WEBPACK_IMPORTED_MODULE_0__views_layouts_AppNavbar__["a" /* default */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__views_layouts_AppFooter__["a" /* default */]
  }
});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppNavbar',

  props: {
    appName: String
  },
  data: function data() {
    return {
      menuHome: '/',
      menuItems: [{ icon: 'smartphone', title: 'Share', link: '/note' }],
      searchAutofocus: false,
      searchText: ''
    };
  },


  methods: {
    searchNote: function searchNote() {
      this.$store.dispatch('submitSearch', this.searchText);
    }
  }
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppFooter'
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NoteAdd__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NoteAlert__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NoteForm__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NoteSnackbar__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',

  components: {
    NoteAdd: __WEBPACK_IMPORTED_MODULE_0__components_NoteAdd__["a" /* default */],
    NoteAlert: __WEBPACK_IMPORTED_MODULE_1__components_NoteAlert__["a" /* default */],
    NoteForm: __WEBPACK_IMPORTED_MODULE_2__components_NoteForm__["a" /* default */],
    NoteSnackbar: __WEBPACK_IMPORTED_MODULE_3__components_NoteSnackbar__["a" /* default */]
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteAdd_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530973a8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteAdd_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(128)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-530973a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530973a8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteAdd_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530973a8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteAdd_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NoteAdd',

  methods: {
    onClick: function onClick() {
      this.$store.dispatch('startNewNote');
    }
  }
});

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteAlert_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f0b7e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteAlert_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(130)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23f0b7e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f0b7e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteAlert_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f0b7e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteAlert_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//

var alertProperties = {
  backgroundColor: '',
  dismissible: false,
  icon: '',
  iconDarkTheme: false,
  text: '',
  transition: '',
  isVisible: false
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NoteAlert',

  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, alertProperties);
  },

  watch: {
    isVisible: function isVisible(data) {
      if (data === false) this.$alert.hide();
    }
  },
  mounted: function mounted() {
    var _this = this;

    // Needed as this.$alert.isVisible cannot be monitored using computed value, with or without getter
    setInterval(function () {
      for (var property in alertProperties) {
        _this[property] = _this.$alert.get(property);
      }
    }, 100);
  }
});

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_buttons_NoteDelete__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_buttons_NoteShare__ = __webpack_require__(171);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NoteForm',

  // Min and Max Length rules need to be initialized even though they are set during mount event
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  validations: {
    code: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], minLength: {}, maxLength: {} },
    notes: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] }
  },

  data: function data() {
    return {
      mode: '',
      code: '',
      notes: ''
    };
  },


  components: {
    NoteDelete: __WEBPACK_IMPORTED_MODULE_2__components_buttons_NoteDelete__["a" /* default */],
    NoteShare: __WEBPACK_IMPORTED_MODULE_3__components_buttons_NoteShare__["a" /* default */]
  },

  methods: {
    /**
     * Initialize data fields by retrieving values from Vuex store
     */
    init: function init() {
      for (var field in this.$data) {
        this[field] = this.$store.state[field];
      }
      // Reset Vuelidate form $dirty flag, otherwise blank fields could trigger error messages
      this.$v.$reset();
    },


    /**
     * Event triggered by keystroke in `code` field
     */
    onInputCode: function onInputCode(value) {
      // Code must be lower case and without space
      this.code = this.$root.$options.filters.formatCode(value);

      // Set $dirty flag of code field
      this.$v.code.$touch();
    },


    /**
     * Submit form, new note or note update
     */
    submit: function submit() {
      this.$v.$touch();

      // Failed validation
      if (this.$v.$invalid) return;

      // Save form data
      var payload = {
        mode: this.mode,
        id: this.id,
        code: this.$root.$options.filters.formatCode(this.code),
        notes: this.notes
      };
      this.$store.dispatch('submitFormNote', payload);

      // Reset dirty flag of form
      this.$v.$reset();
    }
  },

  computed: {
    id: function id() {
      return this.$store ? this.$store.state.id : '';
    },

    /**
     * Form Timestamp will be changed when a new form is created or loaded from database
     */
    formTimesteamp: function formTimesteamp() {
      return this.$store ? this.$store.state.formTimestamp : '';
    },
    errorsCode: function errorsCode() {
      var errors = [];
      if (!this.$v.code.$dirty) return errors;
      !this.$v.code.minLength && errors.push('Code must be at least ' + this.$store.getters.codeMinLength + ' characters long');
      !this.$v.code.maxLength && errors.push('Code must be at most ' + this.$store.getters.codeMaxLength + ' characters long');
      !this.$v.code.required && errors.push('Code is required.');
      return errors;
    },
    errorsNotes: function errorsNotes() {
      var errors = [];
      if (!this.$v.notes.$dirty) return errors;
      !this.$v.notes.required && errors.push('Notes field should not be blank.');
      return errors;
    },
    isFormDirty: function isFormDirty() {
      // All editable form fields should have validation rules
      // Loop through all properties in params to retrieve form field names
      // Note: Current Vuelidate does not contain an 'any' field dirty flag, only 'all' fields dirty flag
      for (var property in this.$v.$params) {
        if (this.$v[property].$dirty) return true;
      }
      return false;
    },
    isSaveButtonDisabled: function isSaveButtonDisabled() {
      if (this.$v.$invalid) return true;
      if (this.isSaving) return true;
      if (this.isFormDirty) return false;
      return true;
    },
    isSaveButtonVisible: function isSaveButtonVisible() {
      return this.$store ? this.$store.getters.isDataEditable : false;
    },
    isSaving: function isSaving() {
      return this.$store ? this.$store.state.isLoading : false;
    }
  },
  watch: {
    formTimesteamp: function formTimesteamp(data) {
      this.init();
    },
    isFormDirty: function isFormDirty(data) {
      // Form should not be dirty if data is not editable
      if (!this.$store.getters.isDataEditable) {
        this.$store.commit('setDirtyFlag', false);
        return;
      }

      this.$store.commit('setDirtyFlag', data);
    }
  },

  mounted: function mounted() {
    // All fields get defaults from Vuex store
    this.init();

    // Dynamically set min and max code length to keep logic in getters module
    this.$options.validations.code.minLength = Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(this.$store.getters.codeMinLength);
    this.$options.validations.code.maxLength = Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["maxLength"])(this.$store.getters.codeMaxLength);
  }
});

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NoteDelete',

  props: {
    color: {
      type: String,
      default: 'white'
    }
  },
  computed: {
    showIcon: function showIcon() {
      return this.$store.getters.isDataEditable && this.$store.getters.linkViewOnly.length > 0;
    }
  },

  methods: {
    onClick: function onClick() {
      this.$store.dispatch('deleteNote');
    }
  }
});

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NoteShare',

  props: {
    color: {
      type: String,
      default: 'white'
    }
  },
  computed: {
    showIcon: function showIcon() {
      return this.$store.getters.linkViewOnly.length > 0;
    }
  },

  methods: {
    onClick: function onClick() {
      this.$store.dispatch('shareNote');
    }
  }
});

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteSnackbar_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dab54da_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteSnackbar_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(6);
function injectStyle (context) {
  __webpack_require__(175)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dab54da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoteSnackbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dab54da_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteSnackbar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dab54da_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoteSnackbar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NoteSnackbar',

  data: function data() {
    return {
      // Set timeout to large number, effectively disabling it, allows module to handle timeout function
      timeout: 9999999,
      visible: false
    };
  },

  watch: {
    visible: function visible(data) {
      if (data === false) this.$snackbar.hide();
    }
  },
  methods: {
    getSetting: function getSetting(property) {
      return this.$snackbar.get(property);
    }
  },
  mounted: function mounted() {
    var _this = this;

    // Needed as this.$snackbar.isVisible cannot be monitored using computed value, with or without getter
    setInterval(function () {
      _this.visible = _this.$snackbar.isVisible;
    }, 100);
  }
});

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NoteAdd__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NoteAlert__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NoteDisplay__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NoteSnackbar__ = __webpack_require__(74);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',

  data: function data() {
    return {
      id: this.$route.params.id
    };
  },

  computed: {
    notes: function notes() {
      return this.$store ? this.$store.state.notes : '';
    }
  },

  components: {
    NoteAdd: __WEBPACK_IMPORTED_MODULE_0__components_NoteAdd__["a" /* default */],
    NoteAlert: __WEBPACK_IMPORTED_MODULE_1__components_NoteAlert__["a" /* default */],
    NoteDisplay: __WEBPACK_IMPORTED_MODULE_2__components_NoteDisplay__["a" /* default */],
    NoteSnackbar: __WEBPACK_IMPORTED_MODULE_3__components_NoteSnackbar__["a" /* default */]
  },

  mounted: function mounted() {
    if (this.id && this.$store) this.$store.dispatch('viewNote', this.id);
  }
});

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NoteDisplay',

  props: {
    notes: {
      type: String,
      default: ''
    }
  },

  computed: {
    formattedNotes: function formattedNotes() {
      return this.$root.$options.filters.formatNotesForDisplay(this.notes);
    }
  }
});

/***/ })

},[112]);


// WEBPACK FOOTER //
// static/js/app.c2b4fcdf766c5eeda8ad.js